import { useEffect } from 'react';
export const useNavigation = _ref => {
  let {
    closeCallback,
    open,
    modalRef
  } = _ref;
  useEffect(() => {
    const handleKeyboardNavigation = event => {
      if (!open || !modalRef.current) {
        return;
      }
      if (event.key === 'Escape' && closeCallback) {
        return closeCallback();
      }
      const elementsToNavigate = modalRef.current.querySelectorAll('a, button:not([disabled]), input:not([readonly]), details, select, textarea, [tabindex]:not([tabindex^="-"])');
      if (event.key === 'Tab' || event.shiftKey) {
        const firstElement = elementsToNavigate.item(0);
        const lastElement = elementsToNavigate.item(elementsToNavigate.length - 1);
        if (!event.shiftKey && event.key === 'Tab' && event.target === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
        if (event.shiftKey && event.key === 'Tab' && event.target === firstElement) {
          event.preventDefault();
          lastElement.focus();
        }
      }
    };
    window.addEventListener('keydown', handleKeyboardNavigation);
    return () => {
      window.removeEventListener('keydown', handleKeyboardNavigation);
    };
  }, [closeCallback, modalRef, open]);
};